import { DateTimePicker, DateTimePickerAndroid } from '@react-native-community/datetimepicker';
import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';
import { EvilIcons, Entypo } from '@expo/vector-icons'; 
import MyText from './MyText';
import MyTextInput from './MyTextInput';
import css from './Style'
import { TouchableOpacity } from 'react-native-gesture-handler';

const MyDatetimePicker = (props) => {
    const [date, setDate] = React.useState(new Date());
    const [mode, setMode] = React.useState('date');
    const [show, setShow] = React.useState(false);

    const [dateString, setDateString] = React.useState('Date');
    const [timeString, setTimeString] = React.useState('Time');

    const padLeft = (num) => {
        if(num < 10)
            return '0'+num;
        return num;
    }

    const onChange = (event, selectedDate, mode) => {
        if(event.type == 'set'){ //dismissed = canceled, set = modified
            const currentDate = selectedDate;
            setShow(false);
            console.log(selectedDate);
            props.onChange(currentDate);
        }
    };

    const FormatDate = (dt) => {
        if(!dt)
            return props.isInfo?'':'Date';
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return padLeft(dt.getDate() + ' ' + months[dt.getMonth()] + ', ' + dt.getFullYear().toString().slice(2));
    }
    const FormatTime = (dt) => {
        if(!dt)
            return props.isInfo?'':'Time';
        return [padLeft(dt.getHours()), padLeft(dt.getMinutes())].join(':');
    }

    const showMode = (currentMode) => {
        if (Platform.OS === 'android') {
            setShow(false);
            DateTimePickerAndroid.open({
                value: props.value??new Date(),
                onChange,
                mode: currentMode,
                is24Hour: true,
                // timeZoneOffsetInMinutes: -new Date().getTimezoneOffset()*2
            });
            // for iOS, add a button that closes the picker
        }
        setMode(currentMode);
    };

    const showDatepicker = () => {
        // setShow(true);
        showMode('date');
    };

    const showTimepicker = () => {
        // setShow(true);
        showMode('time');
    };

    return (
        <View style={styles.container}>
            <View style={styles.date}>
                <TouchableOpacity onPress={() => !props.isInfo?showDatepicker():false}>
                    <MyTextInput icon="date" hasError={props.hasError} editable={false} isInfo={props.isInfo} value={FormatDate(props.value)} style={{color: props.isInfo?'#474747':'#b9bab7', fontSize: props.small&&!props.isInfo?8:10}}/>
                </TouchableOpacity>
            </View>
            <View style={styles.time}>
                <TouchableOpacity onPress={() => !props.isInfo?showTimepicker():false}>
                    <MyTextInput icon="time" hasError={props.hasError} editable={false} isInfo={props.isInfo} value={FormatTime(props.value)} style={{color: props.isInfo?'#474747':'#b9bab7', fontSize: props.small&&!props.isInfo?8:10}}/>
                </TouchableOpacity>
            </View>
            {show && (
                <DateTimePicker
                testID="dateTimePicker"
                value={props.value}
                mode={mode}
                is24Hour={true}
                onChange={onChange}
                />
            )}
        </View>
    );
}
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        display: 'flex',
        width: '100%'
    },
    date: {
        flex: 1,
        marginRight: 2,
        position: 'relative',
        overflow: 'hidden'
    },
    time: {
        flex: 1,
        marginLeft: 2,
        position: 'relative',
        overflow: 'hidden'
    },
})
export default MyDatetimePicker